import Dates from 'components/Dates';
import { CompetencyModuleData } from 'types/dacum/moduleManagement';

export const columns = [
  {
    heading: 'Course Name',
    props: 'courseName',
    sortable: true,
    active: true,
    disabled: false,
    id: 'courseName'
  },
  {
    heading: 'Delivery Mode',
    props: 'deliveryMode',
    sortable: true,
    active: true,
    disabled: false,
    id: 'deliveryMode'
  },
  {
    heading: 'LIA Type',
    props: 'liaType',
    sortable: true,
    active: true,
    disabled: false,
    id: 'liaType'
  },
  {
    heading: 'Created Date',
    props: ({ dateIn }: CompetencyModuleData) => <Dates date={dateIn} />,
    sortable: true,
    active: true,
    disabled: false,
    id: 'dateIn'
  },
  {
    heading: 'Created By',
    props: 'userIn',
    sortable: true,
    active: true,
    disabled: false,
    id: 'userIn'
  },
  {
    heading: 'Action',
    props: 'action',
    sortable: false,
    active: true,
    disabled: false,
    id: 'action'
  }
];
